import { ESourceRelationStatuses } from 'entities/Offer';
import { i18n } from 'i18n';

export const RELATION_STATUSES = () => ({
	[ESourceRelationStatuses.JOINED]: i18n.t('Подключена'),
	[ESourceRelationStatuses.NOT_JOINED]: 'Не подключена',
	[ESourceRelationStatuses.REJECTED]: i18n.t('Отклонена'),
	[ESourceRelationStatuses.VERIFICATION]: i18n.t('На модерации'),
	[ESourceRelationStatuses.DISABLED]: i18n.t('Отключена'),
});
